import ToggleSwitch from "../../../components/toggle/ToggleSwitch";
import { useEffect, useState } from "react";
import { useSocket } from "../../../contexts/SocketContext";
import { useParams } from "react-router-dom";
import { Loader } from "../../../components/loading/Loader";
import { ArrowUturnLeftIcon } from "@heroicons/react/20/solid";

export const DevicesSettingsPage = () => {

  const { deviceToken1, deviceToken2 } = useParams();
  const { socket, subscribeToEvent, unsubscribeFromEvent, sendEvent } = useSocket();

  const [enabledBeeps, setEnabledBeeps] = useState(null);

  const changeBeepState = (beepName, enabled) => {
    setEnabledBeeps({...enabledBeeps, [beepName]: enabled});
    sendEvent('current_data', {['enable_' + beepName]: enabled});
  };

  /* First, request all states */
  useEffect(() => {
    if (!socket || !deviceToken1 || !deviceToken2) return;
    sendEvent('current_data', {'request_enabled_beeps': [deviceToken1, deviceToken2]});
  }, [socket, deviceToken1, deviceToken2]);

  useEffect(() => {
    const handleReceivedData = (data) => {
      if (data?.enabled_beeps) {
        setEnabledBeeps(data.enabled_beeps);
      }
    };

    subscribeToEvent('current_data', handleReceivedData);

    return () => {
      unsubscribeFromEvent('current_data', handleReceivedData);
    };
  }, [socket]);

  const openCalibration = () => {
    window.location = '/calibration/' + deviceToken1 + '/' + deviceToken2;
  };

  if (enabledBeeps === null) return <Loader text="Connexion au système en cours..."/>

  return (
    <div className='w-full h-full p-4 bg-gray-100'>
      <button className="bg-perception-blue text-white px-4 py-2 mb-4 rounded-md flex items-center" onClick={openCalibration}>
        <ArrowUturnLeftIcon className='size-5 mr-2' /> Retour
      </button>
      <div className='bg-white p-4 mb-4'>
        <h2 className='text-lg mb-4 font-semibold'>Paramétrage des notifications</h2>
        <div className="grid grid-cols-[80%_auto] gap-4">
          Envoi d'un email lors d'une alerte relevée
          <ToggleSwitch enabled={enabledBeeps['email']} setEnabled={(enabled) => changeBeepState('email', enabled)}/>
        </div>
      </div>
      <div className='bg-white p-4'>
        <h2 className='text-lg mb-4 font-semibold'>Paramétrage des alertes</h2>
        <div className="grid grid-cols-[80%_auto] gap-4">
          Utilisation de la tronçonneuse thermique
          <ToggleSwitch enabled={enabledBeeps['chainsaw']} setEnabled={(enabled) => changeBeepState('chainsaw', enabled)}/>
          Risque de collision avec godet
          <ToggleSwitch enabled={enabledBeeps['collision']} setEnabled={(enabled) => changeBeepState('collision', enabled)}/>
          Détection d'homme inerte
          <ToggleSwitch enabled={enabledBeeps['deadman']} setEnabled={(enabled) => changeBeepState('deadman', enabled)}/>
          Risque de collision avec engin
          <ToggleSwitch enabled={enabledBeeps['reversing']} setEnabled={(enabled) => changeBeepState('reversing', enabled)}/>
          Intrusion dans la zone de chantier
          <ToggleSwitch enabled={enabledBeeps['intrusion']} setEnabled={(enabled) => changeBeepState('intrusion', enabled)}/>
        </div>
      </div>
    </div>
  );
};